import { useState } from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router'
import { api } from '../api/client'
import type { Erfassung } from '../api/typen'
import AppRahmen from '../komponenten/AppRahmen'

/** Neue Erfassung beginnen: Standort waehlen oder neu eingeben. */
export default function ErfassungNeu() {
  const navigiere = useNavigate()
  const [standort, setStandort] = useState('')

  const standorte = useQuery({
    queryKey: ['standorte'],
    queryFn: () => api.get<{ id: number; name: string }[]>('/api/standorte'),
  })

  const anlegen = useMutation({
    mutationFn: () => api.post<Erfassung>('/api/erfassungen', { standort }),
    onSuccess: (erfassung) => navigiere(`/erfassungen/${erfassung.id}/versorgungspunkt-neu`),
  })

  return (
    <AppRahmen
      titel="Neue Erfassung"
      unter="Standort angeben"
      zurueck="/"
      fuss={
        <button
          className="btn btn-primaer"
          disabled={!standort.trim() || anlegen.isPending}
          onClick={() => anlegen.mutate()}
        >
          Erfassung beginnen
        </button>
      }
    >
      <div className="feld">
        <label className="label" htmlFor="standort">
          Standort
        </label>
        <input
          id="standort"
          type="text"
          placeholder="z. B. Klinikum Frankfurt Höchst"
          value={standort}
          onChange={(ereignis) => setStandort(ereignis.target.value)}
        />
      </div>

      {(standorte.data?.length ?? 0) > 0 && (
        <div className="gruppe">
          <span className="label">Bereits erfasst</span>
          {standorte.data?.map((vorhandener) => (
            <button key={vorhandener.id} className="opt klein" onClick={() => setStandort(vorhandener.name)}>
              {vorhandener.name}
            </button>
          ))}
        </div>
      )}

      {anlegen.isError && <p className="hinweiszeile">{(anlegen.error as Error).message}</p>}
    </AppRahmen>
  )
}
